import axiosInstance from "../axios/axiosInstance";
import Configs from "../configs/Configs";

const clockOutApi = async (data) => {
  try {
    // data example:
    // { notes: "Leaving early today", photo_base64: "..." }
    const response = await axiosInstance.post(Configs.apiClockOutEp, data);

    return {
      data: response.data,
      status: response.status, // HTTP status code
    };
  } catch (error) {
    // Capture the HTTP status code if available
    if (error.response) {
      return {
        data: error.response.data,
        status: error.response.status,
      };
    }
    throw error;
  }
};

export default clockOutApi;
